import type { ReactNode } from 'react'
import type { DevPanelData } from '../types'
import { useIntl } from 'react-intl'
import List from 'components/Common/List'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import ExpandableObjectView from '../ExpandableObjectView'
import MessageBanner from 'LuxKit/Banners/MessageBanner'

interface Props {
  state: DevPanelData
}

function ContextsTab({ state }: Props) {
  const intl = useIntl()
  const { contexts } = state

  return <Pane padding={20}>
    <VerticalSpacer gap={16}>
      <Heading variant="heading5">{intl.formatMessage({
        id: 'temp_dev_panel_contexts_heading',
        defaultMessage: 'Contexts',
      })}
      </Heading>

      <div>
        {contexts.length === 0 && <BodyText variant="medium" italics>{intl.formatMessage({
          id: 'temp_dev_panel_contexts_none',
          defaultMessage: 'None',
        })}
        </BodyText>}

        {contexts.length > 0 && <List>
          {contexts.map(ctx => <li key={ctx.id}>
            <BodyText variant="medium" as="span">{ctx.name}</BodyText><br />
            <ExpandableObjectView value={ctx.value} />
          </li>)}
        </List>}
      </div>

      <MessageBanner kind="informational">
        {intl.formatMessage(
          {
            id: 'temp_dev_panel_contexts_banner',
            defaultMessage: 'Want to add a context here? Use the <code>useReportContextToDevPanel()</code> hook.',
          },
          {
            code: (chunks: ReactNode) => <code key="report-context-hook">{chunks}</code>,
          },
        )}
      </MessageBanner>
    </VerticalSpacer>
  </Pane>
}

export default ContextsTab
